import { TeamRoleStatus, TeamUser } from '@/types/team';

export const getPlayerRoles = (player: TeamUser) => {
  const roles = [];
  if (player.captain === TeamRoleStatus.Yes) {
    roles.push('Captain');
  }
  if (player.scheduler === TeamRoleStatus.Yes) {
    roles.push('Scheduler');
  }
  if (player.manager === TeamRoleStatus.Yes) {
    roles.push('Manager');
  }
  return roles;
};
